module.exports = __webpack_public_path__ + "img/amex.4aca4b78.svg";